const Flickity = require('flickity');

export default () => {

    let slideObjects = [];
    const slideDoms = document.querySelectorAll('[data-featured-products]');

    function initSlides()
    {
        if (!slideObjects.length) {
            for (const slideDom of slideDoms) {
                const parent = slideDom.parentNode;
                const next = parent.querySelector('[data-next]');
                const prev = parent.querySelector('[data-prev]');
                const children = slideDom.children;

                if (children.length === 1) {
                    continue;
                }


                const slide = new Flickity(slideDom, {
                    cellAlign: 'left',
                    contain: true,
                    prevNextButtons: false,
                });

                next.addEventListener('click', (e) => {
                    e.preventDefault();
                    slide.next();
                    return false;
                });

                prev.addEventListener('click', (e) => {
                    e.preventDefault();
                    slide.previous();
                    return false;
                });


                slideObjects.push(slide);



            }
        }
    }

    function destorySlides()
    {
        if (slideObjects.length) {
            for (const slide of slideObjects) {
                slide.destroy();
            }
        }
        slideObjects = [];
    }

    function canHaveSlides()
    {
        return window.innerWidth <= 1024;
    }


    if(slideDoms.length) {
        if (canHaveSlides()) {
            initSlides();
        }

        window.addEventListener('resize', () => {
            if (canHaveSlides()) {
                initSlides();
            } else {
                destorySlides();
            }
        });
    }


}